// extracted by mini-css-extract-plugin
module.exports = {"inputWrapper":"Select_inputWrapper__KJYxN","label":"Select_label__d5_cE","input":"Select_input__fuNQu","error":"Select_error__iHtNn"};